import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
const uuid = require('uuid');
const get = require('lodash/get');

const Globals = require('../../../../app/globals');
const Strings = require('../../../../app/shared/Strings');
const StringUtil = require('../../../../app/shared/StringUtil');
const AssetUtil = require('../../util/asset')
const UriUtil = require('../../util/UriUtil');
const ShortCourseActions = require('../../actions/ShortCourseActions');
const ShortCourseStore = require('../../stores/ShortCourseStore');
import ErrorBox from '../common/ErrorBox';
import WarningBox from '../common/WarningBox';
import SuccessBox from '../common/SuccessBox';

const propTypes = {
    userInfo: PropTypes.object.isRequired,
    role: PropTypes.string.isRequired,
    license: PropTypes.shape({
        token: PropTypes.string.isRequired,
        cost: PropTypes.number.isRequired,
        license_type_token: PropTypes.oneOf([Globals.ecommerce.course_license_types.INDIVIDUAL, Globals.ecommerce.course_license_types.INSTITUTION]),
        course_title: PropTypes.string.isRequired,
        course_hash: PropTypes.string.isRequired,
        course_image_url: PropTypes.string,
        course_description: PropTypes.string,
        course_license_meta_data: PropTypes.shape({
                bullet_points: PropTypes.arrayOf(PropTypes.string),
                assignment_count: PropTypes.number,
                task_count: PropTypes.number,
                credential: PropTypes.bool,
                audience: PropTypes.string,
            }).isRequired,
        issued_at: PropTypes.string,
        expires_at: PropTypes.string,
    }),
    gotoExploreRootView: PropTypes.func.isRequired,
};

const defaultProps = {};

class CoursePurchasePage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            purchaseSuccess: null,
            purchase_warning: null,
            purchase_error: null,
        };

        this.unsubscribes = [
            ShortCourseStore.listen(this.onShortCourseStoreChange)
        ];
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }

    componentDidMount() {
        const queryObj = UriUtil.parseLocationSearchString(window.location);
        if (queryObj.update) {
            if (queryObj.update === 'success') {
                if (!this.state.purchaseSuccess) {
                    this.setState({ purchaseSuccess: true });
                }
            }
            else if (queryObj.update === 'cancel') {
                if (!this.state.purchase_warning) {
                    this.setState({
                        purchase_warning: {
                            message: 'Transaction cancelled'
                        }
                    });
                }
            }
        }
    }

    onShortCourseStoreChange=(storeState)=>{
        let additionalState = {};
        const action = storeState.action;
        if (action.id === this.state.buyCourseActionId) {
            if (!action.error) {
                if (action.sessionId) {
                    console.log("stripe embedded mode not supported"); // This shouldn't happen (but leaving this hook here in case we want to use embedded mode)
                    this.setState({
                        purchase_warning: {
                            message: 'Transaction cancelled'
                        }
                    });
                    
                /* if we were using embedded instead of hosted checkout:
                    this.checkoutPromise = stripe.initEmbeddedCheckout({
                        clientSecret: 'CLIENT_SECRET',
                    });
                    return checkoutPromise.then((checkout)=>{
                        console.log("embedded checkout result",checkout);
                    });
                */
                }
                else if (action.sessionUrl) {
                    // hosted mode when we can't redirect from the server due to CORS
                    console.log("redirecting for session"); // FIXME: remove debug spam
                    window.location.href = action.sessionUrl;
                    return;
                }
                else {
                    // not expected
                }
                additionalState = { ...additionalState, buyCourseActionId: null, purchaseSuccess: true, purchase_warning: null, purchase_error: null };
            }
            else {
                additionalState = { ...additionalState, buyCourseActionId: null, purchaseSuccess: false, purchase_warning: null, purchase_error: action.error };
            }
        }

        if (Object.keys(additionalState) > 0) {
            console.log('CoursePurchasePage onShortCourseStoreChange setState', additionalState);
            this.setState(additionalState);
        }
        
    }
    
    startPurchase=()=>{
        const license = this.props.license;
        /*
            console.log("license:",this.props.license); 
            {
                "token": "TestCoursePurchase",
                "cost": 2999,
                "license_type_token": "individual",
                "course_title": "Test Short Course",
                "course_hash": "b0f76589-9fe7-4a0f-9ab2-b2cc839734f4",
                "course_image_url": "$ASSET_PREFIX/image/normal/35526f5d-dab6-4666-bfdd-52bcab27043a-round_coach_png.png",
                "course_description": null,
                "course_license_meta_data": {
                    "audience": "everyone",
                    "credential": true,
                    "task_count": 4,
                    "bullet_points": [
                        "Purchase Point 1",
                        "Purchase Point 2",
                        ""
                    ],
                    "subcompetency": false,
                    "assignment_count": 12
                },
                "issued_at": null,
                "expires_at": null
            }        */
            
        const licenseTitle = license.course_display_title || license.course_title;
        let licenseDetails = {
            licenseToken: license.token, 
            name: `License ${licenseTitle}`,
            cost: license.cost, // cents
        };
//        if (license.course_description) {
//            licenseDetails.description = license.course_description;
//        };
//        if (license.course_image_url) {
//            let imgSrc = license.course_image_url.replace(/^\$ASSET_PREFIX/, GlobalConfig.AssetStoreUrl);
//            licenseDetails.images = [imgSrc];
//        }
        const currentPath = window.location.pathname;
        let success_url = `${GlobalConfig.ApiUrl}${currentPath}?update=success`;
        let cancel_url = `${GlobalConfig.ApiUrl}${currentPath}?update=cancel`;
        const buyCourseActionId = uuid.v4();
        this.setState({ buyCourseActionId, },()=>{
            return ShortCourseActions.startBuyShortCourseCheckout(buyCourseActionId, { licenseDetails, success_url, cancel_url });
        });


    } // startPurchase
    
    render() {
        const license = this.props.license;
        const badgeImageUrl = get(license, 'course_license_meta_data.badge_image_url');
        const licenseTitle = license.course_display_title || license.course_title;
        let hasValidLicense = false;
        if (this.props.license.issued_at) {
            // TODO deal with expires_at, etc. mechanisms for expiration/renewal not yet determined
            hasValidLicense = true;
        }

        const showPrice = this.props.license.license_type_token === Globals.ecommerce.course_license_types.INDIVIDUAL && !hasValidLicense;
        let callToActionElem;
        if (this.props.license.license_type_token === Globals.ecommerce.course_license_types.INDIVIDUAL) {
            if (hasValidLicense) {
                callToActionElem = (
                    <Button
                        variant="primary"
                        disabled
                        onClick={() => {}}
                    >
                        {Strings['en'].course_purchase_page.YOU_OWN_COURSE}
                    </Button>
                )
            }
            else {
                callToActionElem = (
                    <Button
                        variant="primary"
                        onClick={this.startPurchase}
                    >
                        {Strings['en'].course_purchase_page.BUY_THIS_COURSE}
                    </Button>
                );

            }

        }
        else {
            callToActionElem = (
                <Button
                    variant="primary"
                    onClick={() => { window.location.href = "https://muzzylane.com/contact-us" }}
                >
                        {Strings['en'].course_purchase_page.CALL_US}
                </Button>
            );
        }

        const whatYoullLearnBullets = get(license, 'course_license_meta_data.bullet_points', []);
        const howYoullLearnBullets = get(license, 'course_license_meta_data.bullet_points_how', []);
        const hasSale = !!license.sale_cost;
        return (
            <div className="licensePurchase" title={licenseTitle}>
                {(this.state.purchaseSuccess) &&
                    <SuccessBox className="margin-top-lg">{Strings['en'].course_purchase_page.PURCHASE_SUCCESS_MSG}</SuccessBox>
                }

                <div className="licensePurchaseHeading">
                    <h1 className="licensePurchaseHeading__title">{licenseTitle}</h1>
                    <button
                        className="licensePurchaseHeading__control bare-text-button"
                        onClick={this.props.gotoExploreRootView}
                    >
                        Go back
                    </button>
                </div>

                <div className="licensePurchaseBody">
                    <div className="licensePurchaseBody__top">
                        <div className="licensePurchaseBody__desc">
                            {license.course_description}
                        </div>
                        <div className="licensePurchaseBody__purchase">
                            {(showPrice) &&
                                <div className="license-price">
                                    <span className={!hasSale ? "price" : "price--strikeout"}>
                                        {StringUtil.formatUSD(license.cost)}
                                    </span>
                                    {(hasSale) &&
                                        <span className="price--sale margin-left-sm">
                                            {StringUtil.formatUSD(license.sale_cost)}
                                        </span>
                                    }
                                </div>
                            }
                            <div className="license-cta">
                                {callToActionElem}
                            </div>
                        </div>
                    </div>
                    <div className="licensePurchaseBody__bottom">
                        <div className="licensePurchaseBody__what">
                            <h2>{Strings['en'].course_purchase_page.WHAT_YOULL_LEARN}</h2>
                            <div className="bullet-blocks">
                                {whatYoullLearnBullets.map((item, i) => (
                                    <span className="bullet-item" key={i}>
                                        <span className="fa fa-check-circle-o"/>
                                        <span className="bullet-text">{item}</span>
                                    </span>
                                ))}
                            </div>
                        </div>
                        <div className="licensePurchaseBody__how">
                            <h2>{Strings['en'].course_purchase_page.HOW_YOULL_LEARN}</h2>
                            <div className="bullet-blocks">
                                {howYoullLearnBullets.map((item, i) => (
                                    <span className="bullet-item" key={i}>
                                        <span className="fa fa-check-circle-o"/>
                                        <span className="bullet-text">{item}</span>
                                    </span>
                                ))}
                            </div>
                        </div>
                        <div className="licensePurchaseBody__badge">
                            <h2>{Strings['en'].course_purchase_page.WHAT_YOULL_EARN}</h2>
                            <div className="badgeImgContainer">
                                {(!!badgeImageUrl) &&
                                    <img
                                        className="badge-img"
                                        src={AssetUtil.resolveAssetPath(badgeImageUrl)}
                                        alt={Strings['en'].short_course.skillbuild.BADGE_ALT_DEFAULT}
                                    />
                                }
                            </div>
                            <div className="licensePurchaseBody__purchase__description">
                                {Strings['en'].course_purchase_page.BADGE_SUB_DESC_DEFAULT}
                            </div>
                        </div>
                    </div>

                </div>
                <ErrorBox error={this.state.subscribe_error} />
                {(!!this.state.subscribe_warning) &&
                    <WarningBox>{this.state.subscribe_warning}</WarningBox>
                }
            </div>
        );
    }
}

CoursePurchasePage.propTypes = propTypes;
CoursePurchasePage.defaultProps = defaultProps;

export default CoursePurchasePage;
